"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../..");
var BoldReportsReportViewerPage = /** @class */ (function (_super) {
    __extends(BoldReportsReportViewerPage, _super);
    function BoldReportsReportViewerPage(api, currentUserManager, options) {
        var _this = _super.call(this, __1.PageTypes.BoldReportsReportViewer, 'Report Viewer') || this;
        _this.api = api;
        _this.currentUserManager = currentUserManager;
        _this.options = options;
        _this.observationProvider = new __1.ObservationProvider();
        return _this;
    }
    Object.defineProperty(BoldReportsReportViewerPage.prototype, "reportServiceUrl", {
        get: function () {
            return "".concat(this.api.baseUrl, "api/BoldReports");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoldReportsReportViewerPage.prototype, "bearerToken", {
        get: function () {
            return "Bearer ".concat(this.currentUserManager.authenticationToken);
        },
        enumerable: false,
        configurable: true
    });
    return BoldReportsReportViewerPage;
}(__1.BasePage));
exports.default = BoldReportsReportViewerPage;
